(() => {
  const openAnswer = () => {
    const target = document.getElementById(location.hash.slice(1));
    if (target?.matches('details')) target.open = true;
  };
  window.addEventListener('hashchange', openAnswer);
  const init = () => {
    const menuButton = document.querySelector('[data-kd-menu-open]');
    const mobileNav = document.querySelector('[data-kd-mobile-nav]');
    if (menuButton && mobileNav && !menuButton.dataset.initialized) {
      menuButton.dataset.initialized = 'true';
      const closeMenu = () => { menuButton.setAttribute('aria-expanded', 'false'); menuButton.setAttribute('aria-label', 'Otwórz menu'); mobileNav.hidden = true; };
      menuButton.addEventListener('click', () => {
        const open = menuButton.getAttribute('aria-expanded') === 'true';
        menuButton.setAttribute('aria-expanded', String(!open)); menuButton.setAttribute('aria-label', open ? 'Otwórz menu' : 'Zamknij menu'); mobileNav.hidden = open;
      });
      mobileNav.querySelectorAll('a').forEach(link => link.addEventListener('click', closeMenu));
      document.addEventListener('keydown', event => {
        if (event.key === 'Escape' && !mobileNav.hidden) { closeMenu(); menuButton.focus(); }
      });
      document.addEventListener('click', event => {
        if (!mobileNav.hidden && !event.target.closest('.kd-header')) closeMenu();
      });
      matchMedia('(min-width: 1101px)').addEventListener('change', event => { if (event.matches) closeMenu(); });
    }
    openAnswer();
  };
  init();
  document.addEventListener('shopify:section:load', init);
})();

// Links to FAQ reveal the footer disclosure before the browser scrolls to it.
document.addEventListener('click', event => {
  if (!event.target.closest('a[href="#faq"]')) return;
  const faq = document.getElementById('faq');
  if (faq) faq.open = true;
});
